module.exports = __webpack_public_path__ + "img/idea_carousel.58b0792b.png";